import { render, staticRenderFns } from "./ForgotPassword_Recover.vue?vue&type=template&id=e352fd08&"
import script from "./ForgotPassword_Recover.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword_Recover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports